import React from 'react';
import { Column, InputSubtitle } from './style';
import { Input } from '../../style';

const reg = /^\d+$/;

const InputColumn = ({ changeIndex, activeIndex, value, changeValue, condition, onBlur, text }) => {
    const isActive = activeIndex === condition;

    return (
        <Column width='auto'>
            <Input
                onFocus={() => {
                    changeIndex(condition);
                    changeValue(value.slice(0, -1));
                }}
                onBlur={onBlur}
                isActive={isActive}
                value={value}
                onChange={(event) => {
                    const _value = event.target.value;
                    if (+_value > 100) {
                        return null;
                    } else if (_value === '') {
                        changeValue('');
                    } else if (reg.test(_value)) {
                        changeValue(_value);
                    }
                }}
            />
            <InputSubtitle
                isActive={isActive}
            >
                {text}
            </InputSubtitle>
        </Column>
    );
};

export default InputColumn;
